<div class="h-full flex flex-col overflow-hidden">

  <div class="z-10 px-3 lg:px-6 pt-3 lg:pt-6 bg-white dark:bg-indigo-custom flex-shrink-0">
    <div class="flex justify-between items-center bg-gray-50 dark:bg-secondary-800 rounded-xl px-6 py-3 h-20 p-6">

      <!-- Mobile menu button - only shown on mobile -->
      <button type="button"
              *ngIf="!isDesktop"
              class=" p-2 rounded-md text-secondary focus:outline-none"
              (click)="toggleMobileSidebar()"
              aria-label="Open sidebar menu">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>

      <div>
        <h1 *ngIf="isDesktop" class="text-lg font-semibold text-secondary dark:text-primary-100 leading-tight">ICP Optimization</h1>
        <h1 *ngIf="!isDesktop" class="text-lg font-semibold text-secondary dark:text-primary-100 leading-tight">ICP</h1>
        <span class="text-xs text-secondary/75 dark:text-primary-100 leading-none hidden lg:block mt-1">Complete all the entries to get the most accurate customer profiles.</span>
      </div>

      <div class="flex justify-center items-center space-x-6">
        <div class="flex justify-center items-center">
          <!-- ICP Optimization Chart -->
          <app-icp-optimization-chart class="relative top-0.5"></app-icp-optimization-chart>
          <span class="hidden lg:block text-sm text-secondary dark:text-primary-100 font-semibold">Optimization Level</span>
        </div>

        <!-- Dark Mode Toggle -->
        <app-dark-mode-toggle [mode]="'dashboard'" class="rotate-90 relative left-[0.5rem]"></app-dark-mode-toggle>
      </div>
    </div>
  </div>

  <div class="bg-white dark:bg-indigo-custom flex-1 min-h-0 flex flex-col overflow-hidden pt-6">

    <!-- Centered Loading Spinner for Router-Outlet -->
    <div *ngIf="isLoading" class="flex items-center justify-center w-full" style="min-height: calc(100vh - 170px);">
      <div class="flex flex-col items-center">
        <svg class="animate-spin h-6 w-6 text-blue-royal" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      </div>
    </div>

    <app-tour
      tourName="icp-optimization"
      [autoStart]="true"
      [showButton]="false"
      style="display: block; position: relative; z-index: 100;">
    </app-tour>

    <!-- Always render the form element but use invisible class when loading -->
    <div id="icp-optimization-form"
         class="bg-white dark:bg-secondary-800 rounded-xl pt-4 pb-6 mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8 mb-6 flex-1 min-h-0 flex flex-col overflow-hidden"
         [ngClass]="{'invisible': isLoading && !isTourActive}">

      <!-- Form content is always rendered, but uses opacity transition -->
      <div class="transition-opacity duration-300 flex flex-col min-h-0 flex-1" [ngClass]="{'opacity-0': !dataLoaded, 'opacity-100': dataLoaded}">

        <div class="flex-shrink-0 flex justify-center pb-5">
          <nav class="flex flex-col sm:flex-row w-full sm:w-auto space-y-2 sm:space-y-0 sm:space-x-4" aria-label="Tabs">
            <!-- Step 1: Who I am -->
            <button
              type="button"
              (click)="changeStep(1)"
              [class]="getStepButtonClass(1)"
            >
              <!-- Checkmark Icon -->
              <svg *ngIf="isStepValid(1)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" [class]="'size-5 ' + getIconColorClass(1)">
                <path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" clip-rule="evenodd" />
              </svg>

              <!-- Warning Icon -->
              <svg *ngIf="!isStepValid(1)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" [class]="'size-5 ' + getIconColorClass(1)">
                <path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" clip-rule="evenodd" />
              </svg>

              <span>Who I am</span>
            </button>

            <!-- Step 2: Who I want to talk to -->
            <button
              type="button"
              (click)="changeStep(2)"
              [class]="getStepButtonClass(2)"
            >
              <!-- Checkmark Icon -->
              <svg *ngIf="isStepValid(2)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" [class]="'size-5 ' + getIconColorClass(2)">
                <path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" clip-rule="evenodd" />
              </svg>

              <!-- Warning Icon -->
              <svg *ngIf="!isStepValid(2)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" [class]="'size-5 ' + getIconColorClass(2)">
                <path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" clip-rule="evenodd" />
              </svg>

              <span>Who I want to talk to</span>
            </button>
          </nav>
        </div>

        <form [formGroup]="form" (submit)="submitForm()" method="POST" class="overflow-y-auto min-h-0 flex-1 thin-scrollbar">
          <fieldset [disabled]="isLoading" class="space-y-6 mb-6 p-6 lg:p-0 mx-auto max-w-[35rem]">

            <!-- Step 1 -->
            <section *ngIf="step === 1">

              <div class="grid grid-cols-12 gap-6 mb-9">

                <!-- Name -->
                <div class="col-span-12 md:col-span-12">
                  <app-input-field
                    label="Name"
                    placeholder="Enter ICP name"
                    controlName="name"
                    [required]="true"
                    [showIcon]="true"
                    [maxlength]="255"
                    [type]="'text'"
                  ></app-input-field>
                </div>

                <!-- Description -->
                <div class="col-span-12 md:col-span-12">
                  <app-input-field
                    label="Description"
                    placeholder="Enter ICP description (optional)"
                    controlName="description"
                    [required]="false"
                    [showIcon]="true"
                    [maxlength]="maxTextLength"
                    [showCounter]="true"
                    [type]="'textarea'"
                  ></app-input-field>
                </div>

                <!-- LinkedIn URL -->
                <div class="col-span-12 md:col-span-12" *ngIf="!user?.linkedin_url || !form.get('linkedin_url')?.disabled">
                  <app-input-field
                    label="LinkedIn URL"
                    placeholder="Add your linkedin url"
                    controlName="linkedin_url"
                    [required]="true"
                    [showIcon]="true"
                    [maxlength]="255"
                    [type]="'text'"
                    [pattern]="'^(https?:\/\/)?(www\.)?linkedin\.com\/.*$'"
                    [patternErrorMessage]="'Please enter a valid LinkedIn URL.'"
                  ></app-input-field>
                </div>

                <!-- Benefits of the product and solutions that I sell -->
                <div class="col-span-12 md:col-span-12">

                  <app-input-field
                    label="Benefits of the product and solutions that I sell"
                    placeholder="How do you expect SalesOMMO to help you?"
                    controlName="what_solutions_do_i_sell"
                    [required]="true"
                    [showIcon]="true"
                    [maxlength]="maxLongTextLength"
                    [showCounter]="true"
                    [type]="'textarea'"
                    [tooltip]="'We would like to understand what solutions or products you sell in order to improve how we fine-tune our performance and optimize what SalesOMMO can do for you. (i.e. – if you sell products like servers or notebooks, if you sell software solutions like CRM, ERP, management software for small companies, accountancy software, or other category – please provide the details about what you sell)'"
                    [tooltipPosition]="'right'"
                    [tooltipClass]="'custom-tooltip'"
                  ></app-input-field>

                  <p class="text-xs text-gray-500 mt-3">
                    Tell us what products or solutions you sell (e.g., hardware, software, CRM, ERP) to help us optimize SalesOMMO for you.
                  </p>

                </div>

              </div>

              <!-- Save -->
              <div class="flex flex-col-reverse sm:flex-row sm:justify-center sm:space-x-6 gap-3 sm:gap-0">
                <a routerLink="/dashboard" class="btn btn-cancel w-full sm:w-auto">
                  Cancel
                </a>

                <button type="button" (click)="goToNextStep()" class="btn btn-blue w-full sm:w-auto">
                  Next
                </button>
              </div>

            </section>
            <!-- End of step 1 -->

            <!-- Step 2 -->
            <section *ngIf="step === 2">

              <div class="grid grid-cols-12 gap-6 mb-9">

                <!-- Company size -->
                <div class="col-span-12 md:col-span-12">

                  <div *ngIf="customerCompanySizes && customerCompanySizes.length > 0">
                    <app-combobox-multiselect
                      [label]="'Company size'"
                      [controlName]="'customer_company_size_ids'"
                      [options]="customerCompanySizes"
                      [displayKey]="'name'"
                      [valueKey]="'id'"
                      [required]="true"
                      [showIcon]="true"
                      [maxSelection]="10"
                      (selectionChange)="handleCustomerCompanySizeSelectionChange($event)"
                    ></app-combobox-multiselect>
                  </div>

                </div>

                <!-- Company revenue range -->
                <div class="col-span-12 md:col-span-12">

                  <div *ngIf="companyRevenues && companyRevenues.length > 0">
                    <app-combobox-multiselect
                      [label]="'Company revenue'"
                      [controlName]="'company_revenue_ids'"
                      [options]="companyRevenues"
                      [displayKey]="'name'"
                      [valueKey]="'id'"
                      [required]="true"
                      [showIcon]="true"
                      [maxSelection]="10"
                      (selectionChange)="handleCompanyRevenueSelectionChange($event)"
                    ></app-combobox-multiselect>
                  </div>

                </div>

                <!-- Industry -->
                <div class="col-span-12 md:col-span-12">

                  <div *ngIf="industries && industries.length > 0">
                    <app-combobox-multiselect
                      [label]="'Industry'"
                      [controlName]="'customer_industry_ids'"
                      [options]="customerIndustries"
                      [displayKey]="'name'"
                      [valueKey]="'id'"
                      [required]="true"
                      [showIcon]="true"
                      [maxSelection]="10"
                      (selectionChange)="handleCustomerIndustrySelectionChange($event)"
                    ></app-combobox-multiselect>
                  </div>

                </div>

                <!-- What are the top business pains of my customers that I can solve -->
                <div class="col-span-12 md:col-span-12">

                  <app-input-field
                    label="What are the top business pains of my customers that I can solve"
                    placeholder="What are the main challenges that my customer face and how my product fulfill them?"
                    controlName="challenges_solved"
                    [required]="true"
                    [showIcon]="true"
                    [maxlength]="maxLongTextLength"
                    [showCounter]="true"
                    [type]="'textarea'"
                    [tooltip]="'We would like to understand what challenges your customers potentially have in order to improve the probability that SalesOMMO can identify such challenges and get insights about them from the data we research. (i.e. my customers have performance problems and our product enable them scale better, our customers have difficulties retaining people and our solution help them improve engagement, our solutions help my customers reduce costs, or my product helps my customer control better the issues in a particular area – please provide the details about the pains they have and how they can solve them)'"
                    [tooltipPosition]="'right'"
                    [tooltipClass]="'custom-tooltip'"
                  ></app-input-field>

                </div>

                <!-- Buying Cycle -->
                <!--
                <div class="col-span-12 md:col-span-12">

                  <app-dropdown-select
                    label="Buying Cycle"
                    placeholder="Select buying cycle"
                    controlName="buying_cycle_id"
                    [required]="true"
                    [options]="buyingCycles"
                    [tooltip]="'We would like to understand if most of the customers you talk to are do not know they have a pain, if they already are aware about the problem you can help them tackle, if they are already actively researching for a solution, already evaluating multiple product and solutions, or if they have a standard budget and are looking for vendors to comply with the requirements that fit the budget.'"
                    [tooltipPosition]="'right'"
                    [tooltipClass]="'custom-tooltip'"
                  ></app-dropdown-select>

                </div>
                -->

                <!--
                <div class="col-span-12 md:col-span-12">

                  <app-input-field
                    label="Company profitability"
                    placeholder="What is the profitability of your customer company?"
                    controlName="company_profitability"
                    [required]="false"
                    [maxlength]="255"
                    [type]="'number'"
                  ></app-input-field>

                </div>
                -->

                <!--
                <div class="col-span-12 md:col-span-12">

                  <app-input-field
                    label="Number of locations"
                    placeholder="What is the location number of your customer company?"
                    controlName="location_numbers"
                    [required]="false"
                    [maxlength]="255"
                    [type]="'number'"
                  ></app-input-field>

                </div>
                -->

                <!-- Target Countries -->
                <div class="col-span-12 md:col-span-12">

                  <div *ngIf="countries && countries.length > 0">
                    <app-combobox-multiselect
                      [label]="'Target countries'"
                      [controlName]="'target_country_ids'"
                      [options]="countries"
                      [displayKey]="'name'"
                      [valueKey]="'id'"
                      [required]="false"
                      [showIcon]="true"
                      [maxSelection]="5"
                      (selectionChange)="handleTargetCountrySelectionChange($event)"
                    ></app-combobox-multiselect>
                  </div>

                  <!--
                  <app-input-field
                    label="Target countries"
                    placeholder="Add top 5 countries separated by comma."
                    controlName="target_countries"
                    [required]="false"
                    [maxlength]="255"
                    [type]="'text'"
                  ></app-input-field>
                  -->

                </div>

                <div class="col-span-12">
                  <div class="border-b border-gray-300 my-3"></div>
                </div>

                <!-- Target Departments -->
                <div class="col-span-12 md:col-span-12">
                  <label class="block text-sm font-medium text-gray-700 dark:text-primary-100 mb-2">
                    Target Departments <span class="text-red-500">*</span>
                  </label>
                  <div class="flex flex-wrap gap-2 mb-3">
                    <button
                      type="button"
                      *ngFor="let dept of targetDepartmentOptions"
                      class="px-3 py-1.5 rounded-full text-sm border transition-colors"
                      [ngClass]="isDepartmentSelected(dept.id)
                        ? 'bg-indigo-50 border-indigo-300 text-indigo-700'
                        : 'bg-white border-gray-300 text-gray-600 hover:border-gray-400'"
                      (click)="toggleDepartment(dept.id)">
                      {{ dept.name }}
                    </button>
                  </div>
                  <div *ngIf="isOtherDepartmentSelected" class="flex gap-2 mt-1">
                    <input type="text"
                           class="flex-1 rounded-lg border-gray-300 text-sm focus:ring-indigo-500 focus:border-indigo-500"
                           [attr.maxlength]="maxCustomTargetLength"
                           placeholder="Type a custom department and press Enter"
                           [(ngModel)]="customDepartmentInput"
                           [ngModelOptions]="{standalone: true}"
                           (keydown.enter)="$event.preventDefault(); addCustomDepartment()">
                    <button type="button"
                            class="px-3 py-1.5 rounded-lg border border-gray-300 text-sm text-gray-600 hover:bg-gray-50"
                            (click)="addCustomDepartment()">
                      Add
                    </button>
                  </div>
                  <div class="flex flex-wrap gap-2 mt-3" *ngIf="selectedDepartments.size > 0">
                    <span
                      *ngFor="let dept of selectedDepartments"
                      class="inline-flex items-center gap-1 px-2.5 py-1 bg-indigo-50 text-indigo-700 text-sm rounded-full">
                      {{ dept }}
                      <button type="button" class="text-indigo-400 hover:text-indigo-600" (click)="removeDepartment(dept)">&times;</button>
                    </span>
                  </div>
                  <input type="hidden" formControlName="main_buyer_department" />
                </div>

                <!-- Target Job Titles -->
                <div class="col-span-12 md:col-span-12">
                  <label class="block text-sm font-medium text-gray-700 dark:text-primary-100 mb-2">
                    Target Job Titles <span class="text-red-500">*</span>
                  </label>
                  <div class="flex flex-wrap gap-2 mb-3">
                    <button
                      type="button"
                      *ngFor="let title of targetJobTitleOptions"
                      class="px-3 py-1.5 rounded-full text-sm border transition-colors"
                      [ngClass]="isJobTitleSelected(title.id)
                        ? 'bg-indigo-50 border-indigo-300 text-indigo-700'
                        : 'bg-white border-gray-300 text-gray-600 hover:border-gray-400'"
                      (click)="toggleJobTitle(title.id)">
                      {{ title.name }}
                    </button>
                  </div>
                  <div *ngIf="isOtherJobTitleSelected" class="flex gap-2 mt-1">
                    <input type="text"
                           class="flex-1 rounded-lg border-gray-300 text-sm focus:ring-indigo-500 focus:border-indigo-500"
                           [attr.maxlength]="maxCustomTargetLength"
                           placeholder="Type a custom job title and press Enter"
                           [(ngModel)]="customJobTitleInput"
                           [ngModelOptions]="{standalone: true}"
                           (keydown.enter)="$event.preventDefault(); addCustomJobTitle()">
                    <button type="button"
                            class="px-3 py-1.5 rounded-lg border border-gray-300 text-sm text-gray-600 hover:bg-gray-50"
                            (click)="addCustomJobTitle()">
                      Add
                    </button>
                  </div>
                  <div class="flex flex-wrap gap-2 mt-3" *ngIf="selectedJobTitles.size > 0">
                    <span
                      *ngFor="let title of selectedJobTitles"
                      class="inline-flex items-center gap-1 px-2.5 py-1 bg-indigo-50 text-indigo-700 text-sm rounded-full">
                      {{ title }}
                      <button type="button" class="text-indigo-400 hover:text-indigo-600" (click)="removeJobTitle(title)">&times;</button>
                    </span>
                  </div>
                  <input type="hidden" formControlName="main_buyer_job_title" />
                </div>

                <!-- Exclusion list -->
                <div class="col-span-12 md:col-span-12">

                  <div *ngIf="countries && countries.length > 0">
                    <app-combobox-multiselect
                      [label]="'Country exclusion list'"
                      [controlName]="'country_exclusion_ids'"
                      [options]="countries"
                      [displayKey]="'name'"
                      [valueKey]="'id'"
                      [required]="false"
                      [showIcon]="true"
                      [maxSelection]="5"
                      (selectionChange)="handleCountryExclusionListSelectionChange($event)"
                    ></app-combobox-multiselect>
                  </div>

                  <!--
                  <app-input-field
                    label="Country exclusion list"
                    placeholder="Countries not targeted, no-go industries"
                    controlName="country_exclusion_list"
                    [required]="false"
                    [maxlength]="255"
                    [type]="'text'"
                  ></app-input-field>
                  -->

                </div>

              </div>

              <!-- Save -->
              <div class="flex flex-col-reverse sm:flex-row sm:justify-center sm:space-x-6 gap-3 sm:gap-0">
                <button type="button" (click)="changeStep(1)" class="btn btn-cancel w-full sm:w-auto">
                  Back
                </button>

                <button type="submit" class="btn btn-blue w-full sm:w-auto">
                  Save & Optimize SalesOMMO
                </button>
              </div>

            </section>
            <!-- End of step 2 -->

          </fieldset>
        </form>

      </div>

    </div>

  </div>

</div>
